/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_Format_Video_DurationInputs */

const en_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 min`)
};

const es_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 min`)
};

const de_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 Min.`)
};

const zh_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 分钟`)
};

const ar_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 دقيقة`)
};

const fr_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 min`)
};

const vi_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 phút`)
};

const sw_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dak 60`)
};

const th_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 นาที`)
};

const bs_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 min`)
};

const ja_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60分`)
};

const ko_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60분`)
};

const pt_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 min`)
};

const it_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 min`)
};

const sv_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 min`)
};

const nl_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 min.`)
};

const da_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 min`)
};

const nb_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 min`)
};

const fi_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 min`)
};

const pl_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 min`)
};

const ru_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 мин.`)
};

const tr_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 dk`)
};

const hi_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 मिनट`)
};

const id_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 menit`)
};

const ms_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 minit`)
};

const cs_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 min`)
};

const el_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 λεπτά`)
};

const he_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 דקות`)
};

const af_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 min.`)
};

const hu_lessons_format_video_duration = /** @type {(inputs: Lessons_Format_Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 perc`)
};

/**
* | output |
* | --- |
* | "60 min" |
*
* @param {Lessons_Format_Video_DurationInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const lessons_format_video_duration = /** @type {((inputs?: Lessons_Format_Video_DurationInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_Format_Video_DurationInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_lessons_format_video_duration(inputs)
	if (locale === "de") return de_lessons_format_video_duration(inputs)
	if (locale === "zh") return zh_lessons_format_video_duration(inputs)
	if (locale === "ar") return ar_lessons_format_video_duration(inputs)
	if (locale === "fr") return fr_lessons_format_video_duration(inputs)
	if (locale === "vi") return vi_lessons_format_video_duration(inputs)
	if (locale === "sw") return sw_lessons_format_video_duration(inputs)
	if (locale === "th") return th_lessons_format_video_duration(inputs)
	if (locale === "bs") return bs_lessons_format_video_duration(inputs)
	if (locale === "ja") return ja_lessons_format_video_duration(inputs)
	if (locale === "ko") return ko_lessons_format_video_duration(inputs)
	if (locale === "pt") return pt_lessons_format_video_duration(inputs)
	if (locale === "it") return it_lessons_format_video_duration(inputs)
	if (locale === "sv") return sv_lessons_format_video_duration(inputs)
	if (locale === "nl") return nl_lessons_format_video_duration(inputs)
	if (locale === "da") return da_lessons_format_video_duration(inputs)
	if (locale === "nb") return nb_lessons_format_video_duration(inputs)
	if (locale === "fi") return fi_lessons_format_video_duration(inputs)
	if (locale === "pl") return pl_lessons_format_video_duration(inputs)
	if (locale === "ru") return ru_lessons_format_video_duration(inputs)
	if (locale === "tr") return tr_lessons_format_video_duration(inputs)
	if (locale === "hi") return hi_lessons_format_video_duration(inputs)
	if (locale === "id") return id_lessons_format_video_duration(inputs)
	if (locale === "ms") return ms_lessons_format_video_duration(inputs)
	if (locale === "cs") return cs_lessons_format_video_duration(inputs)
	if (locale === "el") return el_lessons_format_video_duration(inputs)
	if (locale === "he") return he_lessons_format_video_duration(inputs)
	if (locale === "af") return af_lessons_format_video_duration(inputs)
	if (locale === "hu") return hu_lessons_format_video_duration(inputs)
	return en_lessons_format_video_duration(inputs)
});